export default __webpack_public_path__ + "cbf1e950caca5af2e9ec684d5c3f1fce.jpg";